module.exports = __webpack_public_path__ + "img/img5.0efad220.png";